import { useEffect, useState } from "react";

export function usePWAInstall() {
  const [prompt, setPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const ios = /iphone|ipad|ipod/i.test(ua);
    const android = /android/i.test(ua);
    setIsIOS(ios);
    setIsAndroid(android);

    if (
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches
    ) {
      setIsInstalled(true);
      return;
    }

    // Use a prompt already captured before React mounted (index.js)
    if (window.__pwaInstallPrompt) {
      setPrompt(window.__pwaInstallPrompt);
    }

    // Also listen for any future event (e.g. if the page somehow reloads)
    const handler = (e) => {
      e.preventDefault();
      window.__pwaInstallPrompt = e;
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!prompt) return false;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") {
      setIsInstalled(true);
      window.__pwaInstallPrompt = null;
    }
    setPrompt(null);
    return outcome === "accepted";
  };

  return { prompt, install, isInstalled, isIOS, isAndroid };
}
